<template>
  <div>
    <Header :isbig="true" @handleLogin="handleLogin"></Header>
    <Model :type="1" v-show="modelShow" :modelShow.sync="modelShow"></Model>
    <div class="main" v-if="actType != 11">
      <div class="main-left">
        <ul class="menus">
          <li @click="handleChange(item.type)" v-for="(item, index) in menuList"
            :class="actType == item.type && 'item-active'" :key="item.name + index">
            <img :src="actType == item.type ? item.aimg : item.img" alt="" />
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div :class="actType == 6 ? 'main-right2' : 'main-right'">
        <div v-show="actType == 1" style="width:1264px;height:966px">
          <iframe src="/service.html" width="1300px" height="1000px" scrolling="auto" frameborder="no"
            border="0"></iframe>
        </div>

        <!-- <div v-show="actType == 8">
            <p class="act-title">{{ selfTrial.title }}</p>
            <div v-for="(item, index) of selfTrial.data" :key="index">
              <p>{{ item.nav }}</p>
              <p style="text-indent:2rem">{{ item.article }}</p>
            </div>
          </div> -->
        <div v-show="actType == 8" style="width:1264px;height:966px">
          <iframe src="/audit.html" width="1300px" height="1000px" scrolling="auto" frameborder="no" border="0"></iframe>
        </div>
        <div v-show="actType == 7" style="width:1264px;height:966px">
          <iframe src="/refund.html" width="1300px" height="1000px" scrolling="auto" frameborder="no" border="0"></iframe>
        </div>
        <div v-show="actType == 2" style="width:1264px;height:966px">
          <iframe src="/policy.html" width="1300px" height="1000px" scrolling="auto" frameborder="no" border="0"></iframe>
        </div>
        <div v-show="actType == 9" class="nine" style="width:904px;height:966px;border: 1px solid #ccc;">

          <p style="font-weight: 600;color:black">
            用户纠纷的处理
          </p>
          <p style="text-indent:2rem;    color: black">
            在注册、登陆本网站前请务必仔细阅读本《纠纷处理方式》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本服务的同时维护自身合法权益：
          </p>
          <p style="text-indent:2rem;    color: black">
            用户之间纠纷处理方式
          </p>
          <p style="text-indent:2rem;    color: black">
            1.如若用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决，包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。成都金马驹文化科技有限公司将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。
          </p>
          <p style="text-indent:2rem;    color: black">
            2.用户之间发生纠纷的，也可向成都金马驹文化科技有限公司的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他成都金马驹文化科技有限公司要求提供的相关证据。经成都金马驹文化科技有限公司审核确认后，可以给予必要的协助和支持。
          </p>
          <p style="text-indent:2rem;    color: black">
            3.用户与成都金马驹文化科技有限公司之间纠纷处理方式如网站用户对成都金马驹文化科技有限公司的服务有任何异议的，可以向成都金马驹文化科技有限公司的客服人员投诉并举证。查证属实的，成都金马驹文化科技有限公司将立即更正并按照现行法律规定给予用户必要的补偿。
          </p>
        </div>
        <div v-show="actType == 6" class="gywm">
          成都金马驹文化科技有限公司成立于2022年12月19日，致力于原创漫画制作、原创动画制作以及动漫平台打造等业务，团队主要以孵化IP故事为核心业务；动画团队目前拥有全流程动画制作团队，主要开发原创短视频动画IP，将动漫作品制作完成后上架至动漫平台，供广大动漫爱好者观看。
        </div>
        <div v-show="actType == 12" class="gywm2">
          <p>1. 我们非常重视对未成年人个人信息的保护，任何未成年人参加网上活动应事先取得家长或其法定监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关信息。
          </p>
          <p>2. 我们鼓励父母或监护人指导未成年人使用软件服务。
          </p>
          <p>3. 建议未成年人在提交信息之前寻求父母或监护人的同意和指导。
          </p>
          <p>4. 若你是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请与我们取得联系</p>
        </div>
        <div v-show="actType == 4" class="kf-main">
          <div class="kf-info">
            <p>客服电话：010-686 23209</p>
            <p>客服工作时间：上午10:00-12:00 下午13:00-19:00</p>
          </div>
          <p class="kf-desc">
            关注客服公众号，在对话框内输入您在阅读过程中想了解的内容
            热情耐心的客服小助理将火速赶到，竭诚为您解答
          </p>
        </div>
        <div v-show="actType == 13" class="kf-main">
          <div class="kf-desc2">
            <img src="../../assets/qiyue.jpg"  class="kf-img"/>
            <p>申请退款请联系</p>
            <p>客服电话：010-686 23209</p>
            <p>客服工作时间：上午10:00-12:00 下午13:00-19:00</p>
          </div>
          <p class="kf-desc">
            关注客服公众号，在对话框内输入您在阅读过程中想了解的内容
            热情耐心的客服小助理将火速赶到，竭诚为您解答
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="pay_tips">
        <div class="pay_tips_content">
          <div class="app-header__vip-header">
            <img src="../../assets/img_touxiang.png" class="app-header__vip-avater" />
            <div class="app-header__vip-title">
              暂未开通会员
            </div>
          </div>
          <div class="app-header__vip-body">
            <div class="app-header__vip-goods">
              <div class="app-header__vip-goods-item" :class="{ 'is-select': payPrice == index }"
                v-for="(item, index) in priceList" @click="actPrice(index)">
                <div class="app-header__vip-goods-name">{{ item.name }}</div>
                <div class="app-header__vip-goods-price">
                  <div class="app-header__vip-goods-unit" style="color: #D8B55C">
                    ￥
                  </div>
                  <div class="app-header__vip-goods-value" style="color: #D8B55C">
                    {{ (item.price * 0.01).toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="app-header__vip-payment" v-show="actMoney.id">
              <div class="app-header__vip-payment-container">
                <div class="app-header__vip-payment-btn" @click="payOrder(actMoney.id)">
                  <img src="../../assets/icon_zhifubao@2x.png" alt="" />
                  <div class="app-header__vip-payment-btn-text">
                    <span style="color: #ffffff">点击前往支付</span>
                    <span style="color: #ffffff" class="app-header__vip-payment-value">{{ (actMoney.price *
                      0.01).toFixed(2) }}</span>
                    <span style="color: #ffffff">元</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Model from "@/components/dialog/index";
import { orderApi, ordersPay } from "@/api/login";
import { useInfoApi } from "@/api/login.js";

export default {
  components: {
    Model,
  },
  data() {
    return {
      /* 充值相关 */
      priceList: [],
      payPrice: 0,
      actMoney: {},
      userInfo: [],
      /* 其他 */
      modelShow: false,
      actType: 6,

      menuList: [
        {
          name: "用户协议",
          type: 1,
          img: require("../../assets/userprivacy2.png"),
          aimg: require("../../assets/userprivacy.png"),
        },
        {
          name: "隐私协议",
          type: 2,
          img: require("../../assets/privacy2.png"),
          aimg: require("../../assets/privacy.png"),
        },
        {
          name: "退款中心",
          type: 13,
          img: require("../../assets/tk.png"),
          aimg: require("../../assets/tk2.png"),
        },
        {
          name: "退款协议",
          type: 7,
          img: require("../../assets/refund2.png"),
          aimg: require("../../assets/refund.png"),
        },
        {
          name: "自审制度",
          type: 8,
          img: require("../../assets/selftrial.png"),
          aimg: require("../../assets/selftrial2.png"),
        },
        {
          name: "用户纠纷处理",
          type: 9,
          img: require("../../assets/jiufen.png"),
          aimg: require("../../assets/jiufen2.png"),
        },
        {
          name: "关于我们",
          type: 6,
          img: require("../../assets/myself.png"),
          aimg: require("../../assets/my.png"),
        },
        {
          name: "联系我们",
          type: 4,
          img: require("../../assets/icon_lianxikefu.png"),
          aimg: require("../../assets/erji.png"),
        },
        {
          name: '未成年保护制度',
          type: 12,
          img: require("../../assets/baohu.png"),
          aimg: require("../../assets/baohu2.png"),
        }
      ],
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        this.actType = n.query.id
        if (n.query.id == 11) {
          orderApi().then((res) => {
            this.priceList = res.data;
            this.actMoney = this.priceList[this.payPrice];
            // this.hisList = res.data
            // this.numberTip = true
          });
          let info = JSON.parse(localStorage.getItem("info"));
          this.userInfo = info;
        }
      },
      immediate: true
    }
  },

  methods: {
    /* 充值相关 */
    actPrice(e) {
      this.payPrice = e;
      this.actMoney = this.priceList[this.payPrice];
    },
    openNpmber() {
      // alert('666')
      // this.$emit('numberTip',false)
      this.$parent.openNpmber();
    },
    payOrder(e) {
        useInfoApi().then((res) => {
          if (res.code == 4010) {
           this.modelShow=true
          } else {
                  ordersPay({ id: e, siteType: 2 }).then((res) => {
              const div = document.createElement("div");
              div.innerHTML = res.data.form;
              document.body.appendChild(div);
              document.forms[0].submit();
            });
          }
        });
      
      //支付宝支付
     
    },
    /* 其他 */
    handleLogin(val) {
      this.modelShow = val;
    },
    handleChange(type) {
      this.$router.push({
        path: '/system',
        query: {
          id: type
        }
      })
      if (type == 9) {
        this.actType = type;

      } else
        if (type == 7) {
          this.actType = type;
        } else if (type == 8) {
          this.actType = type;
        } else if (type == 6) {
          this.actType = type;
        } else if (type == 1) {
          this.actType = type;
        } else if (type == 2) {
          this.actType = type;
        } else if (type == 3) {
          //消费记录
          this.actType = type;
          this.listPage = 1;
          // this.ordersFetch();
        } else if (type == 4) {
          //联系客服 缺少选中icon
          this.actType = type;
        } else if (type == 5) {
          this.qdnum = 0;
          this.modelShow = true;
        }
    },
  },
};
</script>

<style lang="stylus" scoped>
.main{
    display: flex
    background: #fff
    padding:20px 160px
    .main-left{
   width: 300px;
    height: 100%;
    flex-shrink: 0;

    background: #f8f8f8;
    border-radius: 8px;
    margin-right: 30px;
    min-height: 600px;
    padding: 0 20px 90px;
}
    .main-right{
        height: 100vh
        flex: 1
    }
    .main-right2{
        height: 100vh
         width 700px
        margin-left: 200px
        background: #fff
        box-shadow:0px 0px 14px 5px #ccc
    }
}
.menus {
    li {
      position: relative;
      display: flex;
      align-items: center;
      padding: 20px 3px;
      border-bottom: 1px solid #dfdfdf;
      img {
        width: 30px;
        height: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
      }
      color: #999999;

      cursor: pointer;
      &:hover {
        :before {
          height: 40%;
        }
      }
      :before {
        position: absolute;
        left: -20px;
        top: 30%;
        display: block;
        content: "";
        width: 2px;
        height: 0;
        background-color: #ff2929;
        transition: all 0.3s;
      }
    }
    .item-active {
      p {
        color: #ff2929;
      }
    }
  }
  .gywm{
  color:black;
  width 50%
  font-size:20px
  line-height: 50px
  margin: 245px auto 30px;

}
.kf-img{
  width 300px
  height: 300px
  margin 0 auto
}
.kf-desc2{
  width: 504px;
  text-align: center;
  margin: 0 auto;
  margin-top: 200px

}
.kf-info {
    width: 610px;
    height: 78px;
    border-radius: 10px;
    border: 2px solid #ff2a2a;
    padding: 12px 77px;
    margin: 345px auto 30px;
    p {
      font-size: 20px;
      font-weight: 400;
      color: #ff2a2a;
      line-height: 28px;
      text-align: center;
    }
  }
  .kf-desc {
    width: 504px;
    height: 50px;
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
    margin: 0 auto;
    text-align: center;
  }
  .kf-main{
    margin: 0 auto
  }

  /* 充值相关样式 */
  .pay_tips {
  width: 100%;
  /*background: red;*/
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay_tips_bg {
  width: 100%;
  height: 100%;
  /*background: red;*/
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.pay_tips_content {
  position:fixed;
  top:105px
  height:100%;
  width: 1200px;
  left:55%;
  transform: translateX(-50%);
  background: #ffffff;
}
.app-header__vip-close {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 21px;
  height: 21px;
  cursor: pointer;
}
.app-header__vip-close img {
  width: 100%;
  height: 100%;
}
.app-header__vip-header {
  height: 140px;
  padding: 0 32px;
  background: #fff4d9;
  display: flex;
  align-items: center;
}
.app-header__vip-avater {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-right: 12px;
}
.app-header__vip-title {
  font-size: 24px;
  color: #b88723;
}
.app-header__vip-body {
  padding: 25px 20px 88px;
}
.app-header__vip-goods {
  display: flex;
  flex-wrap: wrap;
  margin: -10px -10px 30px;
}
.app-header__vip-goods-item {
  margin: 10px;
  width: 150px;
  height: 130px;
  border: 2px solid #d8b55c;
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.app-header__vip-goods-name {
  line-height: 1;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 20px;
}
.app-header__vip-goods-price {
  line-height: 1;
  font-weight: 600;
  color: #d8b55c !important;
  display: flex;
  align-items: flex-end;
}
.app-header__vip-goods-value {
  font-size: 36px;
}
.app-header__vip-payment {
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
}
.app-header__vip-payment-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.app-header__vip-payment-btn {
  height: 60px;
  background: #469de2;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.4;
  display: flex;
  align-items: center;
  padding: 0 43px;
  cursor: pointer;
}
.app-header__vip-payment-btn-text {
  display: flex;
  align-items: flex-end;
}
.app-header__vip-payment-btn img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.app-header__vip-payment-value {
  line-height: 1;
  font-size: 30px;
  padding: 0 8px;
}
.is-select {
  background-color: #d8b55c;
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-name {
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-price .app-header__vip-goods-unit {
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-price .app-header__vip-goods-value {
  color: #ffffff !important;
}
.nine{
    line-height: 40px
    padding: 10px 50px
  }
  .gywm2{
    color: #000;
    width: 80%;
    font-size: 20px;
    line-height: 50px;
    margin: 145px auto 30px;
  }
</style>
